import React, {useState} from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import Mycartlogo from "../../images/mycart_logo.jpeg";
// import NewCategory from "./NewCategory";

const ViewCategories = () => {
  return (
    <>
    <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper" style={{paddingRight:"0px", paddingLeft:"0px"}}>
          <Sidebar />

          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                      
                        <h4>Add New Vendor</h4>

                        {/* Our Logo */}
                        
                        <img src={Mycartlogo} alt="My Photo" style={{height:"80px"}}/>
                        
                      {/* Our Categories Table */}

                        <table className="table table-success table-striped table-hover" style={{fontSize:"19px"}}>
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Photo</th>
                            <th scope="col">Category Name</th>
                            <th scope="col">Discount Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">1</th>
                            <td><img src={Mycartlogo} alt="Category photo"/></td>
                            <td>Soap</td>
                            <td>540</td>
                          </tr>
                          <tr>
                            <th scope="row">2</th>
                            <td><img src={Mycartlogo} alt="Category photo"/></td>
                            <td>Dress</td>
                            <td>560</td>
                          </tr>
                          <tr>
                            <th scope="row">3</th>
                            <td><img src={Mycartlogo} alt="Category photo"/></td>
                            <td>Shoe</td>
                            <td>100</td>
                          </tr>
                        </tbody>
                      </table>
                      </div>

                      {/* Add Category Button */}
                      <div>
                        <a href="/new-category">
                        <button type="button" className="btn btn-outline-danger btn-icon-text col-12">
                          <i className="ti-upload btn-icon-prepend"></i>                                                    
                          Add Category
                        </button>
                        </a>
                        </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
    <Footer />
    </div>
    </>
  )
}

export default ViewCategories
